import { isEtsyShopNameVisible, normalizeEtsyShop } from "src/components/default-shop/shopVisibility";
import { isPrioritySellerStatus } from "src/constants/foundingInsiderInvite";

const defaultState = {
  isAuthenticated: false,
  user: {
    id: 0,
    name: "",
    email: "",
    status: 0,
    image: "",
    type: "",
    parent_id: null,
    print_provider_id: null,
    priority_seller: false,
    uuid: "",
  },
  token: "",
  subscription: null,
  isLoading: false,
  loadingButton: false,
  loadingButton2: false,
  skeletonLoading: false,
  userEmail: "",
  activeStep: 0,
  getUsers: false,
  etsyShopName: "",
  userStats: {},
  userMeta: {
    count: 0,
    meta: {},
  },
  userList: [],
  searched: false,
  allUserStats: {},
  allUserStatsLoading: false,
  singleUserStat: {},
  userPagination: {
    page: 1,
    rowsPerPage: 25,
  },
  selectedFilter: "",
  printProviders: [],
  taxDocument: [],
  notificationIsSeen: false,
  countdowntimer: null,
  etsy_shops: [],
  amazon_store_connected: false,
  canva_store_connected: false,
  canva_designs: [],
};

const userReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "Login":
      return {
        ...state,
        isAuthenticated: true,
        user: {
          id: action.payload.id,
          name: action.payload.name,
          email: action.payload.email,
          status: 1,
          image: action.payload.image,
          type: action.payload.user_type,
          parent_id: action.payload.parent_id ?? null,
          print_provider_id: action.payload.print_provider_id ?? null,
          priority_seller: isPrioritySellerStatus(action.payload.priority_seller),
          uuid: action.payload.uuid ?? "",
        },
        token: action.payload.token,
      };
    case "setUserUuid":
      return {
        ...state,
        user: {
          ...state.user,
          uuid: action.payload || "",
        },
      };
    case "Logout":
      return {
        ...state,
        isAuthenticated: false,
        user: {
          name: "",
          email: "",
          status: 0,
        },
        token: "",
      };
    case "isAuthorized":
      return {
        ...state,
        isAuthenticated: action.payload,
      };
    case "setSubscription":
      return {
        ...state,
        subscription: action.payload,
      };

    case "LoadingOn":
      return {
        ...state,
        isLoading: true,
      };
    case "LoadingOff":
      return {
        ...state,
        isLoading: false,
      };

    case "LoadingBtnOn":
      return {
        ...state,
        loadingButton: true,
      };
    case "LoadingBtnOff":
      return {
        ...state,
        loadingButton: false,
      };

    case "LoadingBtn2On":
      return {
        ...state,
        loadingButton2: true,
      };
    case "LoadingBtn2Off":
      return {
        ...state,
        loadingButton2: false,
      };

    case "LoadingSkeletonnOn":
      return {
        ...state,
        skeletonLoading: true,
      };
    case "LoadingSkeletonOff":
      return {
        ...state,
        skeletonLoading: false,
      };

    case "resetPassword":
      return {
        ...state,
        userEmail: action.payload,
      };

    case "activeStep":
      return {
        ...state,
        activeStep: action.payload,
      };

    case "getUsers":
      return {
        ...state,
        getUsers: action.payload,
      };

    case "setEtsyShopName":
      return {
        ...state,
        etsyShopName: action.payload,
      };

    case "setUserStats":
      return {
        ...state,
        userStats: action.payload,
      };

    case "setUserMeta":
      return {
        ...state,
        userMeta: {
          activeUsers: action.payload.activeUsers,
          inActiveUsers: action.payload.inActiveUsers,
          trial: action.payload.trial,
          count: action.payload.count,
          meta: action.payload.meta,
        },
      };

    case "setUserList":
      return {
        ...state,
        userList: action.payload,
      };

    case "setSearched":
      return {
        ...state,
        searched: action.payload,
      };

    case "setAllUserStats":
      return {
        ...state,
        allUserStats: action.payload,
      };

    case "setAllUserStatsLoading":
      return {
        ...state,
        allUserStatsLoading: action.payload,
      };

    case "setSingleUserStat":
      return {
        ...state,
        singleUserStat: action.payload,
      };

    case "setUserPagination":
      return {
        ...state,
        userPagination: {
          page: action.payload.page,
          rowsPerPage: action.payload.rowsPerPage,
        },
      };

    case "setSelectedFilter":
      return {
        ...state,
        selectedFilter: action.payload,
      };

    case "setPrintProviders":
      return {
        ...state,
        printProviders: action.payload,
      };

    case "setTaxDocument":
      return {
        ...state,
        taxDocument: action.payload,
      };

    case "setNotificationIsSeen":
      return {
        ...state,
        notificationIsSeen: action.payload,
      };

    case "setCountdownTimer":
      return {
        ...state,
        countdowntimer: action.payload,
      };

    case "setEtsyShops":
      return {
        ...state,
        etsy_shops: (action.payload || []).map(normalizeEtsyShop),
      };

    case "toggleEtsyShopVisibility":
      return {
        ...state,
        etsy_shops: (state.etsy_shops || []).map((shop) => {
          if (String(shop.shop_id) !== String(action.payload)) return shop;
          return {
            ...shop,
            is_visible: isEtsyShopNameVisible(shop) ? 0 : 1,
          };
        }),
      };

    case "setDefaultEtsyShop":
      return {
        ...state,
        etsy_shops: state.etsy_shops.map((shop) => ({
          ...shop,
          is_default: shop.shop_id === action.payload ? 1 : 0,
        })),
      };

    case "setAmazonStoreConnected":
      return {
        ...state,
        amazon_store_connected: action.payload,
      };

    case "setCanvaStoreConnected":
      return {
        ...state,
        canva_store_connected: action.payload,
      };

    case "setCanvaDesigns":
      return {
        ...state,
        canva_designs: action.payload || [],
      };

    default:
      return state;
  }
};

export default userReducer;
